//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Alert,
  AlertIcon,
  Badge,
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Collapse,
  Flex,
  Link,
  Stack,
  Text,
  Textarea,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import Icon from "./ui-elements/Icon";
import { observer } from "mobx-react-lite";
import React from "react";
import { possessiveNoun } from "../utils/functions";
import Countdown from "./data-display/Countdown";

type Props = {
  stopDate: any;
  onClick: (args: any) => void;
  clientName: string;
  error: any;
  isSubmitting: boolean;
};

const AcceptRequest = observer(
  ({ stopDate, onClick, clientName, error, isSubmitting, ...rest }: Props) => {
    const [response, setResponse] = React.useState({ reason: "", comment: "" });
    const [confirmations, setConfirmations] = React.useState([]);
    const [isInvalid, setIsInvalid] = React.useState(false);

    const handleChange = (value) => {
      setConfirmations(value);
      if (value.length === 2) setIsInvalid(false);
    };

    const handleClick = () => {
      if (confirmations.length === 2) {
        const reason = "Request accepted";
        setIsInvalid(false);
        onClick({ ...response, reason });
      } else {
        setIsInvalid(true);
      }
    };

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [show, setShow] = React.useState(false);
    const handleToggle = () => setShow(!show);

    return (
      <Flex
        height="100%"
        direction="column"
        justifyContent="space-between"
        {...rest}
      >
        <Stack spacing={[3, 4]}>
          <Alert
            rounded="fbRadius"
            status="warning"
            variant="subtle"
            lineHeight="short"
          >
            <AlertIcon /> You can't cancel or decline after accepting this
            request
          </Alert>
          <Text>
            Please check the terms below to accept {possessiveNoun(clientName)}{" "}
            request:
          </Text>
          §
          <CheckboxGroup
            defaultValue={confirmations}
            onChange={handleChange}
            size="lg"
          >
            <VStack spacing={"1rem"}>
              <Checkbox
                value="lesson-details"
                alignItems="baseline"
                borderColor="rgb(227, 231, 237)"
                isInvalid={
                  isInvalid && !confirmations.includes("lesson-details")
                }
              >
                <Stack ml={2} fontSize="md" spacing={1}>
                  <Text fontWeight="medium">Lesson details and pricing</Text>
                  <Text opacity={0.8}>
                    The lesson price, subjects, schedule and location are fine
                    by me.
                  </Text>
                </Stack>
              </Checkbox>

              <Checkbox
                value="pre-assessment"
                alignItems="baseline"
                borderColor="rgb(227, 231, 237)"
                isInvalid={
                  isInvalid && !confirmations.includes("pre-assessment")
                }
              >
                <Stack ml={2} fontSize="md" spacing={1}>
                  <Box fontWeight="medium">
                    Tuteria Pre-assessments&trade;{" "}
                    <Badge ml={1} variant="solid" colorScheme="purple">
                      New
                    </Badge>
                  </Box>
                  <Text opacity={0.8}>
                    I understand I may be required to administer pre-assessment
                    tests.
                  </Text>
                </Stack>
              </Checkbox>
            </VStack>
          </CheckboxGroup>
          <Stack mt={-2}>
            <Link
              ml="36px"
              fontSize="sm"
              onClick={() => (isOpen ? onClose() : onOpen())}
              color="blue.500"
            >
              {isOpen ? "Hide this" : "What is this?"}
            </Link>
            <Collapse in={isOpen}>
              <Text opacity={0.8}>
                <b>Tuteria Pre-assessments&trade;</b> are designed to help you
                quickly identify students' learning gaps and weak areas so that
                lessons are tailored to address these needs. You may be required
                to spend a bit more time to conduct this test on the first day
                of lessons. If so, you will be added to a WhatsApp group for
                this booking.
              </Text>
            </Collapse>
          </Stack>
          <Stack mt={[-1, 0]}>
            <Link color="blue.500" onClick={handleToggle}>
              Have any comments?
            </Link>

            <Collapse in={show}>
              <Textarea
                resize="none"
                placeholder="This is optional, and will only be seen by Tuteria staff."
                onChange={(e) =>
                  setResponse({ ...response, comment: e.target.value })
                }
              />
            </Collapse>
          </Stack>
        </Stack>

        <Stack py={[5, 6]} align="center">
          {isInvalid && (
            <Stack mb={1} isInline align="center" color="red.500">
              <Icon name="error" size={4} />
              <Text fontSize="sm">Please check each of the terms above</Text>
            </Stack>
          )}

          {error && (
            <Text color="red.500" fontSize="sm">
              An error occurred. Please try again
            </Text>
          )}

          <Button
            size="lg"
            loadingText="Submitting"
            isFullWidth
            onClick={handleClick}
            colorScheme="blue"
            isLoading={isSubmitting}
          >
            Confirm
          </Button>

          <Stack isInline mt={1} align="center">
            <Icon name="passing-time" size={4} color="red.500" />
            <Box fontSize="sm" pr={1}>
              <Countdown date={stopDate} variant="plain" /> left to respond
            </Box>
          </Stack>
        </Stack>
      </Flex>
    );
  },
);

export default AcceptRequest;
